import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { CallLog } from '../../../../../types/call-logs';
import './cells.scss';
import { OverlayTooltip } from '../../../../../../../shared/design-system/components/overlay';
import { formatNoteTimestamp } from '../../../../../../../shared/utils';
import { RootState } from '../../../../../../../store/root-reducer';

interface IProps {
  row: CallLog;
}

const DateTimeCell: React.FC<IProps> = memo(({ row }) => {
  // Add null check
  const userTimezone = useSelector((state: RootState) => state?.home?.timeZone);
  if (!row || !row.dateTime) {
    return <span>-</span>;
  }

  return (
    <div className="date-time-cell">
      <OverlayTooltip
        text={formatNoteTimestamp(row.dateTime, true, userTimezone)}
      >
        <span>
          {formatNoteTimestamp(row.dateTime, false, userTimezone, true)}
        </span>
      </OverlayTooltip>
    </div>
  );
});

DateTimeCell.displayName = 'DateTimeCell';

export default DateTimeCell;
